import React from "react";
import * as styles from "./SummaryBlock.module.css";

interface Props {
    children: React.ReactNode;
    label?: React.ReactNode;
    className?: string;
}

export function SummaryBlockList(props: { children: React.ReactNode; className?: string; }) {
    return <div className={[styles.summaryList, props.className].filter(Boolean).join(" ")}>{props.children}</div>;
}

export function SingleSummaryBlock(props: Props) {
    return (
        <SummaryBlockList className={props.className}>
            <SummaryBlock label={props.label}>{props.children}</SummaryBlock>
        </SummaryBlockList>
    );
}

function SummaryBlock(props: Props) {
    return (
        <div className={[styles.summaryItem, props.className].filter(Boolean).join(" ")}>
            {props.label && <div className={styles.summaryLabel}>{props.label}</div>}
            <div className={styles.summaryValue}>{props.children}</div>
        </div>
    );
}

export default SummaryBlock;
